import React from "react";
// import { AttentionSeeker } from "react-awesome-reveal";
// import helloLight from '../media/hello-light.webp';
import helloLight from "../media/Aniket_pilankar.png";
import helloDark from "../media/Aniket_pilankar.png";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";

const Home = ({ darkMode }) => {
  return (
    <div>
      {/* <AttentionSeeker> */}
      <Row>
        <Col lg={12} xs={12}>
          <h1 className="display-3 hello" align="center">
            HELLO!<code> I'm Aniket Pilankar</code>
          </h1>
          <h2 className="lead" align="center">
            I{" "}
            <span
              class="txt-rotate"
              data-period="2000"
              // data-rotate='[ " am a Full-Stack Developer.", " love solving DSA problems.", " love playing guitar and traveling.",  " am a learner for life!" ]'>
              // data-rotate='[" Software Developer Engineer at Acadly "]'
            >
              {/* am a Software Developer Engineer at Acadly */}
              am a Frontend Developer
            </span>
          </h2>
        </Col>
      </Row>
      <Row>
        <Container align="center">
          <Col lg={12} xs={12}>
            <img
              src={darkMode ? helloDark : helloLight}
              alt="hello"
              className="hello-img"
              height="1050px"
              width="203px"
            />
          </Col>
        </Container>
      </Row>
      {/* </AttentionSeeker> */}
      <br />
      <hr />
    </div>
  );
};

export default Home;
